import { NavLink } from 'react-router-dom';
import { IconStudio, IconJobs } from './Icons.js';

/**
 * BottomTabBar — navigasi utama app.
 *
 * Tab "Storyboard" dihapus: aksesnya via JobDetailPage → "Review Storyboard".
 * Tab storyboard langsung (tanpa ID) menyebabkan confusion — fetch storyboard
 * dari job terbaru tanpa filter status, bisa tampil storyboard lama yang sudah
 * approved dan tidak bisa diedit lagi.
 */
const TABS = [
  { to: '/',     label: 'Studio', Icon: IconStudio, end: true  },
  { to: '/jobs', label: 'Jobs',   Icon: IconJobs,   end: false },
] as const;

export function BottomTabBar() {
  return (
    <nav className="bottom-tab-bar" aria-label="Navigasi utama">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            `bottom-tab-bar__item tap-target${isActive ? ' bottom-tab-bar__item--active' : ''}`
          }
        >
          <span className="bottom-tab-bar__icon" aria-hidden>
            <tab.Icon size={22} />
          </span>
          <span className="bottom-tab-bar__label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
